var alignment_rtlignore_default = {
  "alignLeft": "GqUOK",
  "textWrapNowrap": "cUvJ3",
  "alignRight": "wd-QU",
  "alignCenter": "K2JB9",
  "sizeFullWidth": "RagiS",
  "renderedInTable": "BLP72",
  "sizeOriginal": "nIOSG",
  "sizeContent": "y5ZF4",
  "sizeSmall": "Tn1oP",
  "sizeSmallCenter": "NPWyP",
  "flex": "VUhgt",
  "LEFT": "NmSHq",
  "CENTER": "tqtZs",
  "RIGHT": "RmpdQ",
  "AUTO": "aQZ5Y",
  "JUSTIFY": "_41Chx"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
